import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
//import '../theme/index.css'
import locale from 'element-ui/lib/locale/lang/en'

import Vue2Editor from "vue2-editor";
import GlobalComponents from './globalComponents'
import VueFriendlyIframe from 'vue-friendly-iframe';
import VueMask from 'v-mask'
import VueCompositionAPI from '@vue/composition-api'
import VueQrcodeReader from "vue-qrcode-reader";

Vue.use(ElementUI, { locale })
Vue.use(Vue2Editor);
Vue.use(GlobalComponents)
Vue.use(VueFriendlyIframe);
Vue.use(VueMask);
Vue.use(VueCompositionAPI)
Vue.use(VueQrcodeReader);

Vue.config.productionTip = false

// navigation guards before each
router.beforeEach((to, from, next) => {
	if (to.matched.some(record => record.meta.requiresAuth)) {
		if (localStorage.getItem('accessToken') === null) {
			next({
				path: '/login',
				query: { redirect: to.fullPath }
			})
		} else {
      next()
      window.scroll(0, 0)
		}
	} else {
		next() // make sure to always call next()!
    window.scroll(0, 0)
	}
})

const serverURL = "https://eta-api-sg.easytailorapp.com/api/";
axios.defaults.baseURL = serverURL
//axios.defaults.baseURL = 'http://146.190.26.161/'
axios.defaults.headers.common = {
  'Accept': 'application/json',
  'Content-Type': 'application/json'
};

Vue.mixin({
	data() {
		return {
        print_process: false,
        master_server_url: 'https://api-lb.easytailorapp.com/',
        master_report_url: 'https://api-lb.easytailorapp.com/reports/',
        master_url: 'https://api-lb.easytailorapp.com/printPDF/?',
        graphColors: ['#A0D2EB', '#E5EAF5', '#D0BDF4', '#8458B3', '#e30ad4', '#DEE500'],
        weekdays: [
                  { id: 0, dayName: 'Sunday' }, 
                  { id: 1, dayName: 'Monday' }, 
                  { id: 2, dayName: 'Tuesday' }, 
                  { id: 3, dayName: 'Wednesday' },
                  { id: 4, dayName: 'Thursday' },
                  { id: 5, dayName: 'Friday' },
                  { id: 6, dayName: 'Saturday' }
                  
        ],
        masterMonths: [
            {id: 0, name: 'January'},
            {id: 1, name: 'February'},
            {id: 2, name: 'March'},
            {id: 3, name: 'April'},
            {id: 4, name: 'May'},
            {id: 5, name: 'June'},
            {id: 6, name: 'July'},
            {id: 7, name: 'August'},
            {id: 8, name: 'Sepetember'},
            {id: 9, name: 'October'},
            {id: 10, name: 'November'},
            {id: 11, name: 'December'}
        ],
        currentPopUpAccess: null
      }
    },
    computed: {
        getCurrencyFormat() {
          return this.$store.state.master.currency_format
        },
        getDeletableRows() {
            let checkedRows = []
            
            this.dataGrid.checkedRows.forEach(element => {
                checkedRows.push(element.id)
            });
            return checkedRows
        },
        getDataGridPaginationLimit() {
            return this.dataGrid.perPage
        },
        getCurrentDate() {

          let monthNumber = (new Date().getMonth())+1
          if(monthNumber<10) {
            monthNumber = "0"+monthNumber
          }
          return new Date().getFullYear()+'/'+monthNumber+'/'+new Date().getDate()
        }
    },
    methods: {
      sortByNumericPropertyDesc(property){  
        return (a,b) => {  
          if(a[property] < b[property])  
              return 1;  
          else if(a[property] > b[property])  
              return -1;  
      
          return 0;  
        }  
      },
      changeDate(value, $offset = false) {
          
          var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
          
          let date = new Date(value)
          if($offset) {
              date = new Date( date.getTime() + Math.abs(date.getTimezoneOffset()*60000) )
          }
          if(value === undefined) {
              return ''
          }
          if(value === null) {
              return ''
          }
          let year = value.substring(0, 4)
          let month = value.substring(5, 7)
          let day = value.substring(8, 10)

          return monthNames[parseInt(month)-1]+' '+day+' '+year

      },   
      convertCurrencyToShort(labelValue) {
        const sign = Math.sign(Number(labelValue));
        // Nine Zeroes for Billions
        return Math.abs(Number(labelValue)) >= 1.0e9
          ? (sign * (Math.abs(Number(labelValue)) / 1.0e9)).toFixed(2) + "B"
          : // Six Zeroes for Millions
          Math.abs(Number(labelValue)) >= 1.0e6
          ? (sign * (Math.abs(Number(labelValue)) / 1.0e6)).toFixed(2) + "M"
          : // Three Zeroes for Thousands
          Math.abs(Number(labelValue)) >= 1.0e3
          ? (sign * (Math.abs(Number(labelValue)) / 1.0e3)).toFixed(2) + "K"
          : Math.abs(Number(labelValue));
      },  
      formatCurrency(value) {

          let currency = this.getCurrencyFormat.currency_symbol

          let maxFraction = this.getCurrencyFormat.default_currency_max_fraction

          var n = value, 
          c = maxFraction, 
          d = this.getCurrencyFormat.default_currency_decimal_separator, 
          t = this.getCurrencyFormat.default_currency_thousand_separator, 
          s = n < 0 ? "-" : "", 
          i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))), 
          j = (j = i.length) > 3 ? j % 3 : 0;
          
          if(maxFraction>0) {
              return currency+" "+s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
          } else {
              return currency+" "+s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t);
          }
                
      },
      changeFocus(nextElementId) {
          if(document.getElementById(nextElementId) !== null) {
            document.getElementById(nextElementId).focus()
          }
          
        },
        invalidEmailAddress(emailAddress) {
          if(emailAddress.indexOf('@') === -1 || emailAddress.indexOf('.') === -1) {
            return true
          }
          return false
        },
        isDateRangeValid(startDate, endDate) {
            var fDate = new Date(startDate);
            var lDate = new Date(endDate);
            if(fDate !== lDate) {

              if(fDate <= lDate) {
                  return true;
              }
              return false;
            } else {
              return true;
            }
            
        },
        monthDiff(d1, d2) {
          
          if(d1 != null && d2 !=null) {
            var months;
            months = (d2.getFullYear() - d1.getFullYear()) * 12;
            months -= d1.getMonth() + 1;
            months += d2.getMonth();
            return months <= 0 ? 0 : months+1;
          } else {
            return 0
          }
        },
        dayDiff(d1, d2) {
          
          if(d1 != null && d2 !=null) {
            return Math.floor((Date.UTC(d2.getFullYear(), d2.getMonth(), d2.getDate()) - Date.UTC(d1.getFullYear(), d1.getMonth(), d1.getDate()) ) /(1000 * 60 * 60 * 24));
          } else {
            return 0
          }
        },
        checkIfModuleAccessAvailable(routePath, accessType) {
          
          let routeIndex = this.$store.getters.getAllMenus.findIndex((t) => t.route_path == routePath)
          let routeAccessInfo = this.$store.getters.getAllMenus[routeIndex]
          if(routeIndex >= 0) {
            if(accessType == 'can_view' && routeAccessInfo.can_view) {
                return true
            } else if(accessType == 'can_add' && routeAccessInfo.can_add) {
                return true
            } else if(accessType == 'can_edit' && routeAccessInfo.can_edit) {
                return true
            } else if(accessType == 'can_delete' && routeAccessInfo.can_edit) {
                return true
            }
          
            if(accessType != 'can_view') {
              this.$store.commit('displayMessageAlert', {message: 'You do not have access, please contact your administrator.', type: 'Error'})    
            }
          }
          return false

        },
        printWindow(portId) {
          this.print_process = true

          setTimeout(() => {
                const prtHtml = document.getElementById(portId).innerHTML;

                // Get all stylesheets HTML
                let stylesHtml = '';
                for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
                stylesHtml += node.outerHTML;
                }

              var iframe = document.createElement('iframe');
              iframe.style.display = "none";

              var html = `<!DOCTYPE html>
              <html>
              <head>
                  ${stylesHtml}
              </head>
              <body>
                  ${prtHtml}
              </body>
              </html>`;
              document.body.appendChild(iframe);
              iframe.contentWindow.document.open();
              iframe.contentWindow.document.write(html);
              
              iframe.contentWindow.print();
              iframe.contentWindow.document.close();
          }, 1000);
           setTimeout(() => {
            this.print_process = false
           }, 300);
           
        }
		
    }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js